import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, CreditCard, Zap, FileDown } from 'lucide-react';
export const Hero: React.FC = () => {
  return <section className="py-12 md:py-20 px-4 max-w-5xl mx-auto" data-id="element-149">
      <div className="flex flex-col items-center text-center" data-id="element-150">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-earth font-bold leading-tight mb-6 max-w-4xl" data-id="element-151">
          Dormí tranquila esta noche, <br className="hidden md:block" data-id="element-152" />
          <span className="text-terracotta italic font-medium" data-id="element-153">
            sin el fuego en el pecho.
          </span>
        </h1>

        <p className="font-sans text-lg md:text-xl text-earth-light mb-10 max-w-3xl leading-relaxed" data-id="element-154">
          El método de Sustitución Proactiva diseñado para mamás primerizas en
          argentina. Accedé al alivio real hoy, sin dejar el mate y sin vivir a
          base de galletitas de agua.
        </p>

        <div className="w-full max-w-2xl mx-auto mb-10 relative" data-id="element-155">
          <div className="absolute inset-0 bg-terracotta/5 rounded-3xl blur-2xl transform scale-105" data-id="element-156"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hAjf9WjgLsshdMDJqGpRnd/ChatGPT_Image_29_abr_2026,_15_44_05.png" alt="Embarazo Sin Acidez en iPad y iPhone" className="w-full h-auto relative z-10 drop-shadow-xl rounded-xl" data-id="element-157" />
        </div>

        <div className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-158">
          <CTAButton className="w-full mb-4" data-id="element-159">
            QUIERO LA GUÍA Y LOS 5 BONUS
          </CTAButton>

          <div className="flex items-center gap-2 mb-6 font-sans" data-id="element-160">
            <span className="text-earth-light line-through text-sm" data-id="element-161">
              Antes: $28.400
            </span>
            <span className="text-earth font-bold text-lg" data-id="element-162">
              Hoy: $14.200 ARS
            </span>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm text-earth-light font-sans" data-id="element-163">
            <div className="flex items-center gap-1" data-id="element-164">
              <Zap size={14} className="text-sage" data-id="element-165" />
              <span data-id="element-166">Acceso inmediato</span>
            </div>
            <span className="hidden md:inline text-terracotta/30" data-id="element-167">•</span>
            <div className="flex items-center gap-1" data-id="element-168">
              <FileDown size={14} className="text-sage" data-id="element-169" />
              <span data-id="element-170">PDF descargable</span>
            </div>
            <span className="hidden md:inline text-terracotta/30" data-id="element-171">•</span>
            <div className="flex items-center gap-1" data-id="element-172">
              <CreditCard size={14} className="text-sage" data-id="element-173" />
              <span data-id="element-174">Pago único</span>
            </div>
            <span className="hidden md:inline text-terracotta/30" data-id="element-175">•</span>
            <div className="flex items-center gap-1" data-id="element-176">
              <ShieldCheck size={14} className="text-sage" data-id="element-177" />
              <span data-id="element-178">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};